<template>
  <div class="ui left aligned container">
    <div class="ui form">
      <div class="inline fields">
        <label>间隔</label>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="5" v-model="interval" @change="load()">
            <label>5分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="15" v-model="interval" @change="load()">
            <label>15分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="30" v-model="interval" @change="load()">
            <label>30分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="60" v-model="interval" @change="load()">
            <label>1小时</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="180" v-model="interval" @change="load()">
            <label>3小时</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="360" v-model="interval" @change="load()">
            <label>6小时</label>
          </div>
        </div>
      </div>
    </div>
    <v-chart id="chart" :options="options" theme="light"></v-chart>
  </div>
</template>

<script>
  import axios from 'axios';
  import ECharts from 'vue-echarts';

  export default {
    name: "BearerDetails",
    components: {
      'v-chart': ECharts
    },
    data() {
      return {
        id: this.$route.params.id,
        interval: 5,
        page: 0,
        options: null,
      };
    },
    beforeRouteUpdate(to, from, next) {
      this.id = to.params.id;
      next();
    },
    mounted() {
      this.id = this.$route.params.id;
      this.load();
    },
    methods: {
      load() {
        axios.get('/bearers/' + this.id + '?interval=' + this.interval).then(response => {
          this.options =
            {
              title: {
                text: response.data[0].name
              },
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: ['应援票数增幅', '元气票数增幅']
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'time'
              },
              yAxis: {
                type: 'value'
              },
              series: [
                {
                  name: '应援票数增幅',
                  type: 'line',
                  data: response.data.map(e => [e.time, e.inc1])
                },
                {
                  name: '元气票数增幅',
                  type: 'line',
                  data: response.data.map(e => [e.time, e.inc2])
                },
              ]
            };
        });
      }
    }
  };
</script>

<style scoped>

</style>
